// extracted by mini-css-extract-plugin
module.exports = {"ldsSpinner":"Spinner_ldsSpinner__33AYg","SpinnerFullPageContainer":"Spinner_SpinnerFullPageContainer__1Xeso","SpinnerAbsoluteContainer":"Spinner_SpinnerAbsoluteContainer__sOrS8"};